<div class="tags-section">
  <mat-expansion-panel displayMode="flat" [expanded]="expandTags" (opened)="onPanelOpened()" (closed)="onPanelClosed()">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <p>Tags</p>
      </mat-panel-title>
    </mat-expansion-panel-header>

    @for (tag of packageFolderTags(); track tag) {
      <div class="flexCenterAlign">
        <mat-form-field class="w-p-100">
          <mat-select [placeholder]="tag.TagKey" [value]="getInitialTagValue(tag.TagKey)"
            [disabled]="isQualitySystemTag(tag.TagKey)"
            (selectionChange)="setTagValue({TagKey: tag.TagKey, TagValue: $event.value, TagsDisplayOrder: tag.TagsDisplayOrder}, tag.TagKey)"
            panelClass="mat-select-panel single-select-panel-container"
            [attr.id]="buildControlId('tag-select', tag.TagKey)">
            <mat-option class="no-select-option"
              (mousedown)="$event.stopPropagation(); $event.preventDefault();">
              <div class="p-8">
                <mat-form-field appearance="outline" class="w-p-70">
                  <input
                    matInput
                    (input)="filterTagValues(tag, $any($event.target).value)"
                    placeholder="Search"
                    (click)="$event.stopPropagation()"
                    (mousedown)="$event.stopPropagation()"
                    (keydown)="$event.stopPropagation()"
                    />
                    <button mat-icon-button matSuffix aria-label="Clear search"
                      (click)="clearSearchInput(tag, $event)">
                      <i class="icon-ic-remove-doc"></i>
                    </button>
                  </mat-form-field>
                </div>
              </mat-option>
              @for (option of (tag.TagDropDownValues || tag.TagValues); track option) {
                <mat-option [value]="option.Code || option">
                  {{ option.Code || option }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <button type="button" class="pointCursor crossicon" color="accent" mat-icon-button
            [disabled]="isQualitySystemTag(tag.TagKey)"
            (click)="clearTagValue(tag.TagKey)"
            [attr.id]="buildControlId('clear-tag', tag.TagKey)">
            <i class="icon-ic-remove-doc pointCursor" matTooltipClass="tooltip-style" matTooltipPosition="above"
              matTooltip="Remove tag">
            </i>
          </button>
        </div>
      }
    </mat-expansion-panel>

    @if (expandTags) {
      <div class="d-flex flex-column align-items-end mt-20 gap-10">
        <button mat-button [color]="isFromGeneralInformation ? 'accent' : 'primary'" [class]="'w-100' + (isFromGeneralInformation ? ' general-save-btn' : ' ghost fillbg')" (click)="savePackageFolderTags()"
          [attr.id]="buildControlId('save-button', isFromGeneralInformation ? 'general' : 'bulk')">
          Save
        </button>
        @if (!isFromGeneralInformation) {
          <button mat-stroked-button color="primary" (click)="cancelPackageFolderTags()"
            class="w-p-100 custom-cancel-button"
            [attr.id]="buildControlId('cancel-button')">
            Cancel
          </button>
        }
      </div>
    }

  </div>
